import { z } from 'zod'

// bulk last-price lookup for the picker table: a list of instrument uids in,
// a uid → last-price map out (price in the instrument's own currency).
export const instrumentLastPricesRequestSchema = z.object({
  uids: z.array(z.string()),
})
export type InstrumentLastPricesRequestDto = z.infer<typeof instrumentLastPricesRequestSchema>

export const instrumentLastPricesResponseSchema = z.record(z.string(), z.number())
export type InstrumentLastPricesResponseDto = z.infer<typeof instrumentLastPricesResponseSchema>
